export const CERT_ENTITLEMENT_VALUEKEY = {
  USER: '-4',
  ROLE: '-2',
  ACCOUNT: '0',
  ENTITLEMENT: 1, // any >= 0
};

export const ACTION_BUTTON_GROUP_KINDS = {
  TILE: 'detailsTile',
  FOOTER: 'sidePanelFooter',
};

export const ACTION_BUTTON_KINDS = {
  APPROVE: 'approve',
  BELONGS_TO_ME: 'belongsToMe',
  REJECT: 'reject',
  TERMINATE: 'terminated',
  REASSIGN: 'reassign',
  DOES_NOT_BELONG_TO_ME: 'doesNotBelongToMe',
  CONSULT: 'consult',
  WORKS_FOR_ME: 'worksForMe',
  DOES_NOT_WORK_FOR_ME: 'doesNotWorksForMe',
  EXTEND_END_DATE: 'extendEndDate',
  CONDITIONAL_CERTIFIY: 'conditionalCertifiy',
  DECOMMISSION: 'decommission',
  EDIT: 'edit',
};

export const CERTIFIED = {
  NO_ACTION: -1,
  RESET: 0,
  WORKS_FOR_ME: 2,
  APPROVE: 2,
  REVOKED: 3,
  TERMINATED: 4,
  CONDITIONAL_CERTIFIY: 5,
  EXTEND_END_DATE: 6,
  BELONGS_TO_ME: 2,
  DOES_NOT_BELONG_TO_ME: -1,
  UPDATE_ACCOUNT_OWNER: 1,
};

export const EO_CERTIFIED = {
  RESET: -1,
  WORKS_FOR_ME: 1, // BELONGS TO ME
  APPROVE: 1,
  REVOKED: 0,
  DECOMMISSION: 0,
  DOES_NOT_BELONG_TO_ME: 4,
  CONDITIONAL_CERTIFIY: 5,
};

export const ACTION_ICON_KINDS = {
  CHECK: 'Check',
  EXTEND_END_DATE: 'ExtendEndDate',
  CONSULT: 'Consult',
  APPROVE: 'approve',
  BELONGS_TO_ME: 'approve',
  REJECT: 'reject',
  TERMINATE: 'terminate',
  REASSIGN_USER: 'reassignUser',
  REASSIGN_ITEM: 'reassignItem',
  DOES_NOT_BELONG_TO_ME: 'reassignItem',
  CONFIRM_MANAGER: 'confirmManager',
  CHANGE_END_DATE: 'changeEndDate',
  CONSULT_WITH_PEERS: 'consultWithPeers',
  EDIT: 'edit',
  DECOMMISSION: 'reject',
};

export const TERMINATE_USER_DATA = {
  TITLE: 'Terminate User and Access?',
  DESC: 'Do you want to terminate this user and revoke all their access?',
  SUBDESC:
    'Termination won’t be fulfilled right away. It’ll take effect after you finish your review and submit.',
  NOTE: 'If you don’t submit by the due date, termination will occur automatically at that time.',
  PLACEHOLDER: 'Provide a reason for your decision',
  PRIMARYBUTTON: 'Terminate',
  SECONDARYBUTTON: 'Cancel',
};

export const REJECT_ACTION_DATA = {
  TITLE: 'Reject this ',
  DESC: 'Access won‘t be removed right away. It’ll take effect after you finish your review and submit.',
  NOTE: 'If you don’t submit by the due date, access will be removed automatically at that time.',
  PRIMARYBUTTON: 'Reject',
  SECONDARYBUTTON: 'Got it',
  CANCELBUTTON: 'Cancel',
};

export const ENABLE_INDIVIDUAL_COMMENTS_FOR_USER = {
  DOES_NOT_WORK_FOR_ME: 'DOES NOT WORK FOR ME',
  WORKS_FOR_ME: 'WORKS FOR ME',
  NORESPONSE: 'NORESPONSE',
  TERMINATED: 'TERMINATED',
  REASSIGN: 'RE-ASSIGN',
  EXTEND_END_DATE: 'EXTEND_END_DATE',
};

export const ENABLE_INDIVIDUAL_COMMENTS_FOR_ACC_ENT_ROLES = {
  APPROVE: 'YES',
  REJECT: 'NO',
  NORESPONSE: 'NORESPONSE',
  REASSIGN: 'RE-ASSIGN',
  REASSIGNSTEP2: 'REASSIGNSTEP2',
  BELONGS_TO_ME: 'BELONGSTOME',
  DOES_NOT_BELONG: 'DOESNOTBELONG',
  CONSULT: 'CONSULT',
  DOES_NOT_BELONG_TO_ME: 'DOES NOT BELONG TO ME',
};

export const CHECKBOX_CONSTANTS = {
  CONSULT_POPOVER: 'show_consultPopover',
  REASSIGN: 'show_reassignWarnModal',
  CONSULT_WARN: 'show_consultWarnModal',
  AUTO_REVOKE_WARN: 'shouldNotShow_autoRevokeWarnBanner_',
};

export const PREDEFINED_COMMENTS_FOR_ACTION = {
  APPROVE: 'APPROVE',
  BELONGS_TO_ME: 'BELONGSTOME',
  REJECT: 'REJECT',
  WORKS_FOR_ME: 'CONFIRM',
  DOES_NOT_WORK_FORME_WITHOUT_REASSIGNMENT:
    'DOESNOTWORKFORMEWITHOUTREASSIGNMENT',
  DOES_NOT_WORK_FOR_ME: 'DOESNOTWORKFORMEWITHREASSIGNMENT',
  DOES_NOT_BELONG_TO_ME: 'DOESNOTBELONGTOME',
  REASSIGN: 'REASSIGNACCESS',
  CONSULT: 'CONSULT',
  TERMINATE: 'TERMINATE',
  EXTEND_END_DATE_USERS: 'EXTENDENDDATEFORUSERS',
  EXTENDENDDATEFORACCESS: 'EXTENDENDDATEFORACCESS',
  REVIEWANDSUBMIT: 'REVIEWANDSUBMIT',
  DECOMMISSION: 'DECOMMISSION',
};
